import { render } from "./Payment.vue?vue&type=template&id=5ebdc972&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=5ebdc972&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ebdc972"

export default script